import { Link } from 'react-router-dom';
import CargarArchivo from '../Components/CargarArchivo';
import InformesSinInformar from '../Components/InformesSinInformar';
import InformesInformados from '../Components/InformesInformados';
import React, { useState } from 'react';
import { EnumPathRutas } from '../../../Utils/Enumeradores/ComunEnum';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';

const CargaInformesPage = () => {
	const [renderizar, setRenderizar] = useState()
	const [key, setKey] = useState('carga');

	return (
		<div className="container-fluid">
			<div className="row mb-4">
				<div className="col-12">
					<div className="breadcrumbs">
						<ul>
							<li><Link to={EnumPathRutas.Inicio}> Inicio</Link></li>
							<li><a href="" onClick={(e) => { e.preventDefault(); window.location.reload(false); }}>Informes Conservacion</a></li>
							<li><a href="">Carga</a></li>
						</ul>
					</div>
				</div>
			</div>

			<div className="row" style={{ height: 'calc(100% - 20px)' }}>
					<div className="col-12">
						
						<div className="bg-white rounded p-4">
						<Tab.Container id="users" defaultActiveKey="carga">
							<Nav className='mb-3 nav-tabs'>
								<Nav.Item>
									<Nav.Link eventKey="carga" onClick={() => setKey('carga')}>
										Carga Archivo
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="informados" onClick={() => setKey('informados')}>
										Archivos Informados
									</Nav.Link>
								</Nav.Item>
							</Nav>
						<Tab.Content>
								<Tab.Pane eventKey="carga">
									<div className='border rounded p-4 h-100'>
										<CargarArchivo
											key={key}
											resetKey={key}
											setRenderizar={setRenderizar}
										/>
									</div>
									<div className='border rounded p-4 h-100 mt-3'>
										<InformesSinInformar
											setRenderizar={setRenderizar}
											renderizar={renderizar}
										/>
									</div>
								</Tab.Pane>
								<Tab.Pane eventKey="informados">
									<InformesInformados/>
								</Tab.Pane>
							</Tab.Content>
						</Tab.Container>
					</div>

					</div>
				</div>

		</div>
	)
}
export default CargaInformesPage;
